/*
 * Mobile - Blog - Blog Header  --  variant: Menu On Load + Sticky On Scroll + Simple Header
 * Moonshot experiment id: 61265455   status in Moonshot on 2026-08-27: DEPLOYED   started: 2026-01-30
 * Audience: MOBILE   Target: blog   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_blog_m_header
 */
MGExp.run('blog_m_header', { name: "Mobile - Blog - Blog Header / Menu On Load + Sticky On Scroll + Simple Header", platform: 'mobile', target: 'blog' }, function () {
  !(function () {
    let t = [],
      i = [];
    !(async function (o, n, a, e, r) {
      let s = {
        multi_target_selectors: t,
        page_identifier_selector: "body.template-article-studio-full",
        exclude_from_timeout: i,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(o, n, a, e, r, s);
    })(
      ["#mobile-secondary-nav", "body"],
      ".msai-hide-secondary-nav",
      function (t, i) {
        const [o, n] = i;
        (o.classList.add("msai-hide-secondary-nav"),
          n.style.setProperty("padding-top", "100px", "important"));
      },
      "#mobile-secondary-nav{display:block !important;visibility:visible !important;opacity:1 !important;transform:translateY(0) !important}.top-part{justify-content:center !important}.open-original-cart-mobile,.top-part > button:first-child,.announcement-container{display:none !important}",
    );
  })();
});
